import * as React from 'react';
import { PaymentElement, ExpressCheckoutElement } from '@stripe/react-stripe-js';
import { Loader } from '@mobalytics/shared';
import { css } from '@emotion/react';
import { PaymentConfirmationLayout } from '../../../payment-confirmation-layout/payment-confirmation-layout.component';
import { StripeConfirmationInfo } from '../stripe-flow.types';
import { useStripeNewFlowPaymentConfirmation } from './stripe-new-flow-payment-confirmation.hook';

interface Props {
  className?: string;
  submitButtonLabel: string;
  confirmationInfo: StripeConfirmationInfo;
  productAbbreviation: string;
  paypalButton?: React.ReactNode;
}

export const StripeNewFlowConfirmation: React.FC<Props> = (props) => {
  const { submitButtonLabel, confirmationInfo, productAbbreviation, paypalButton } = props;
  const { loading, confirmPayment, error } = useStripeNewFlowPaymentConfirmation(confirmationInfo, productAbbreviation);
  const [paymentElementLoading, setPaymentElementLoading] = React.useState(true);

  return (
    <PaymentConfirmationLayout
      loading={loading}
      disabled={paymentElementLoading}
      buttonLabel={submitButtonLabel}
      onSubmit={confirmPayment}
      errorMessage={error}
    >
      {paymentElementLoading && <Loader />}
      <ExpressCheckoutElement
        onConfirm={confirmPayment}
        options={{
          layout: {
            maxColumns: 2,
            maxRows: 0,
            overflow: 'never',
          },
          paymentMethods: {
            applePay: 'always',
            googlePay: 'always',
          },
        }}
        css={formCss}
      />
      {paypalButton}
      <div css={formCss}>
        <PaymentElement onLoaderStart={() => setPaymentElementLoading(false)} options={{ layout: 'accordion' }} />
      </div>
    </PaymentConfirmationLayout>
  );
};

const formCss = css`
  margin-top: 8px;
`;
